const LogoIcon = () => {
  return (
    <svg
      width="32"
      height="24"
      viewBox="0 0 32 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Gradera"
    >
      <defs>
        <linearGradient
          id="li-grad"
          x1="0"
          y1="15.9322"
          x2="26.3804"
          y2="15.9322"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#66509B" />
          <stop offset="0.29" stopColor="#2D86C5" />
          <stop offset="0.45" stopColor="#0CA6DF" />
          <stop offset="0.63" stopColor="#2FB3CB" />
          <stop offset="0.81" stopColor="#57C2B6" />
          <stop offset="1" stopColor="#26C3F3" />
        </linearGradient>
      </defs>
      {/* G crossbar — white for sidebar visibility */}
      <path
        d="M24.729 6.66936V8.88817H27.7393C27.7263 9.44368 27.606 9.93137 27.3654 10.3448C27.1119 10.7808 26.7478 11.1167 26.2699 11.3557C25.792 11.5947 25.2199 11.7142 24.547 11.7142C23.8058 11.7142 23.1654 11.5365 22.6225 11.1813C22.0796 10.826 21.6602 10.306 21.3611 9.62778C21.0653 8.94631 20.9158 8.12273 20.9158 7.15059C20.9158 6.17844 21.0653 5.3581 21.3677 4.68309C21.67 4.00808 22.0893 3.49455 22.6322 3.14251C23.1719 2.78724 23.8025 2.61284 24.521 2.61284C24.9046 2.61284 25.2556 2.66128 25.571 2.75495C25.8863 2.84861 26.1724 2.98749 26.4194 3.16512C26.6665 3.34275 26.8811 3.56237 27.0534 3.81752C27.2256 4.07267 27.3622 4.36657 27.4565 4.69923H30.47C30.3725 4.00808 30.1579 3.37828 29.8198 2.80339C29.4817 2.2285 29.0461 1.73436 28.5162 1.31772C27.9831 0.901091 27.3752 0.57812 26.6893 0.34881C26.0033 0.1195 25.2654 0.00646019 24.4689 0.00646019C23.5425 0.00646019 22.681 0.167946 21.8878 0.490917C21.0946 0.813889 20.3957 1.2822 19.7975 1.89907C19.1993 2.51595 18.7345 3.26847 18.4029 4.15341C18.0713 5.04158 17.9055 6.04925 17.9055 7.17965C17.9055 8.08074 18.0128 8.90755 18.2208 9.65684C18.9555 10.109 19.6675 10.6064 20.3501 11.1522C21.5107 12.0759 22.5607 13.1191 23.4904 14.2592C23.8253 14.3012 24.1666 14.327 24.5242 14.327C25.701 14.327 26.7478 14.0912 27.6613 13.6165C28.5747 13.1417 29.2899 12.4667 29.8133 11.5882C30.3334 10.7097 30.5935 9.66007 30.5935 8.43278V6.67582H24.7225L24.729 6.66936Z"
        fill="white"
      />
      {/* G gradient swoosh */}
      <path
        d="M26.3447 23.8579C25.2816 19.3783 22.6972 15.3185 19.066 12.4247C15.3243 9.44368 10.8057 7.86758 6.00096 7.86758C3.99519 7.86758 2.00569 8.1518 0.0844446 8.71377L0.00317383 8.73637V9.02382H0.113702C10.7472 9.35971 20.4379 14.9374 26.0358 23.9419L26.0683 23.9968H26.3772L26.3447 23.8547V23.8579Z"
        fill="url(#li-grad)"
      />
    </svg>
  );
};

export default LogoIcon;
